/* ============================================================
   HHM Variant Picker + Quantity + ATC form handler
   ============================================================ */

(function() {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach(form => {
    const variantIdInput = form.querySelector('[data-product-variant-id]');
    const atcBtn         = form.querySelector('[data-atc-btn]');
    const atcLabel       = form.querySelector('[data-atc-label]');
    const atcPrice       = form.querySelector('[data-atc-price]');
    const qtyInput       = form.querySelector('[data-qty-input]');
    const qtyDisplay     = form.querySelector('[data-qty-display]');
    const qtyMinus       = form.querySelector('[data-qty-minus]');
    const qtyPlus        = form.querySelector('[data-qty-plus]');

    if (!variantIdInput) return;

    // Load all variants from embedded JSON
    const sectionId    = variantIdInput.id.replace('ProductVariantId-', '');
    const jsonEl       = document.getElementById('ProductVariantsJson-' + sectionId);
    let   allVariants  = [];
    if (jsonEl) {
      try { allVariants = JSON.parse(jsonEl.textContent); } catch (e) {}
    }

    // Track selected value per option position: { 1: 'Original', 2: '2 of Each' }
    const selectedOptions = {};

    // Seed from the initially-selected variant
    const initialId      = parseInt(variantIdInput.value, 10);
    const initialVariant = allVariants.find(v => v.id === initialId) || allVariants[0];
    if (initialVariant) {
      if (initialVariant.option1) selectedOptions[1] = initialVariant.option1;
      if (initialVariant.option2) selectedOptions[2] = initialVariant.option2;
      if (initialVariant.option3) selectedOptions[3] = initialVariant.option3;
    }

    // Find the variant that matches all currently selected options
    function findVariant() {
      return allVariants.find(v => {
        if (selectedOptions[1] !== undefined && v.option1 !== selectedOptions[1]) return false;
        if (selectedOptions[2] !== undefined && v.option2 !== selectedOptions[2]) return false;
        if (selectedOptions[3] !== undefined && v.option3 !== selectedOptions[3]) return false;
        return true;
      }) || null;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // Apply a resolved variant to all UI surfaces
    function applyVariant(variant) {
      if (!variant) return;

      const available      = variant.available;
      const formattedPrice = formatMoney(variant.price);

      variantIdInput.value = variant.id;

      if (atcPrice) atcPrice.textContent = formattedPrice;
      if (atcLabel) atcLabel.textContent = available ? 'Add to Cart' : 'Sold Out, For Now.';
      if (atcBtn) {
        if (available) { atcBtn.removeAttribute('data-reserve'); }
        else           { atcBtn.setAttribute('data-reserve', 'true'); }
      }

      // Shop Pay hidden input
      const spInput = document.querySelector('[data-shop-pay-input]');
      if (spInput) spInput.value = variant.id;

      // Notify sticky ATC + product media via custom event
      document.dispatchEvent(new CustomEvent('hhm:variant-selected', {
        detail: {
          variantId:   variant.id,
          price:       formattedPrice,
          available:   available,
          option1:     variant.option1 || '',
          nickname:    variant.option1 || '',
          mediaId:     variant.featured_media?.id || null
        }
      }));

      // Navigate image carousel to variant's featured media
      if (variant.featured_media?.id) {
        const productMedia = document.querySelector('product-media');
        if (productMedia) {
          productMedia.dispatchEvent(new CustomEvent('updateVariant', {
            detail: { featured_media: { id: variant.featured_media.id }, option1: variant.option1 }
          }));
        }
      }
    }

    // ---- Option button clicks ----
    form.closest('[data-section-id], section, [id]')?.querySelectorAll('[data-option-btn]')
      .forEach(btn => {
        btn.addEventListener('click', () => {
          const position = parseInt(btn.dataset.optionPosition, 10);
          const value    = btn.dataset.optionValue;

          selectedOptions[position] = value;

          // Update selected state within this option group only
          document.querySelectorAll(`[data-option-btn][data-option-position="${position}"]`)
            .forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          const variant = findVariant();
          if (variant) applyVariant(variant);
        });
      });

    // Fallback: legacy [data-variant-btn] support for sections still using flat variant cards
    document.querySelectorAll('[data-variant-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('[data-variant-btn]').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const vid       = btn.dataset.variantId;
        const price     = btn.dataset.variantPrice;
        const available = btn.dataset.variantAvailable === 'true';

        variantIdInput.value = vid;
        if (atcPrice) atcPrice.textContent = price;
        if (atcLabel) atcLabel.textContent = available ? 'Add to Cart' : 'Sold Out, For Now.';

        const spInput = document.querySelector('[data-shop-pay-input]');
        if (spInput) spInput.value = vid;

        document.dispatchEvent(new CustomEvent('hhm:variant-selected', {
          detail: {
            variantId: vid,
            price:     price,
            available: available,
            option1:   btn.dataset.variantOption1 || '',
            nickname:  btn.dataset.variantNickname || '',
            mediaId:   parseInt(btn.dataset.variantMediaId, 10) || null
          }
        }));

        const mediaId = parseInt(btn.dataset.variantMediaId, 10);
        if (mediaId) {
          const productMedia = document.querySelector('product-media');
          if (productMedia) {
            productMedia.dispatchEvent(new CustomEvent('updateVariant', {
              detail: { featured_media: { id: mediaId }, option1: btn.dataset.variantOption1 }
            }));
          }
        }
      });
    });

    // ---- Qty stepper ----
    function getQty() { return parseInt(qtyInput?.value || '1', 10); }
    function setQty(n) {
      const val = Math.max(1, n);
      if (qtyInput)   qtyInput.value        = val;
      if (qtyDisplay) qtyDisplay.textContent = val;
    }

    if (qtyMinus) qtyMinus.addEventListener('click', () => setQty(getQty() - 1));
    if (qtyPlus)  qtyPlus.addEventListener('click',  () => setQty(getQty() + 1));

    // ---- ATC submit ----
    if (atcBtn) {
      atcBtn.addEventListener('click', e => {
        e.preventDefault();
        const variantId = variantIdInput.value;
        const qty       = getQty();
        if (!variantId) return;

        atcBtn.disabled = true;
        const originalLabel = atcLabel?.textContent;
        if (atcLabel) atcLabel.textContent = 'Adding...';

        window.HHMCart?.add(variantId, qty)
          .finally(() => {
            atcBtn.disabled = false;
            if (atcLabel) atcLabel.textContent = originalLabel;
          });
      });
    }
  });

})();
